import { objectCopy } from "../../shared/utils";
import Capture from "../../mainInterface/js/Capture";

const state = {
  cameraInStance: new Capture(),
  camraMode: {
    modegray: { mode: 1, gamma: 1.0, rgain: 9.2, ggain: 3.2, bgain: 2.35, blacklevel: 0.45 },
    modergb: { mode: 0, gamma: 1.0, rgain: 3.0, ggain: 1.0, bgain: 1.065, blacklevel: 0.1 }
  },
  upDownInCapture: "", // 拍摄界面的radio值
  hasUpImgPath: false, // 是否拍摄过了上睑板腺
  ifLoading: true, // 是否加载loading
  isInited: null
};
const mutations = {
  CAMERA_MODE_CHANGED: (state, modecfg) => {
    state.camraMode = objectCopy(modecfg);
  },
  CAMERA_INITED: (state, isInited) => {
    state.isInited = isInited;
  }
};
const actions = {
  camraModeChanged({ commit }, modecfg) {
    commit("CAMERA_MODE_CHANGED", modecfg);
  },
  cameraChangeState({ commit }, state) {
    commit("CAMERA_INITED", state);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/capture.js